// extracted by mini-css-extract-plugin
export default {"actions":"O7dbw5NQk9yd71W3V5fEqQ=="};